import React, { useEffect, useState } from 'react'
import { Box, MenuItem, Select, Typography, TextField, Checkbox, ListSubheader } from '@mui/material'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { BackArrowIcon, GoToLiveIcon, HighDemandIcon, TopRatingIcon, TrendingIcon, ExportIcon } from '../../icons'
import { useMemo } from 'react'
import debounce from 'lodash.debounce'
import { fetchCourseCategoryList } from '../../api/courseApi'
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Button from '@mui/material/Button';
import { downloadWebLeads } from '../../api/counselingApi';
import { useNotification } from '../../hooks/useNotification';
import { downloadAdmissionList } from '../../api/admissionApi';
import { downloadPaymentRequestList } from '../../api/paymentRequestApi';
export const tagOptions = [
    { label: 'Trending', value: 'trending', icon: <TrendingIcon fontSize="small" /> },
    { label: 'Top Rated', value: 'topRated', icon: <TopRatingIcon fontSize="small" /> },
    { label: 'High Demand', value: 'highDemand', icon: <HighDemandIcon fontSize="small" /> },
    { label: 'Uncategorized', value: 'uncategorized', icon: <HighDemandIcon fontSize="small" /> },
]

export const enrollmentOptions = [
    { label: 'Admission Open', value: 'admissionOpen', color: '#22c55e' },
    { label: 'Few Seats Left', value: 'fewSeatsLeft', color: '#8b5cf6' },
    { label: 'Closes Soon', value: 'closesSoon', color: '#f97316' },
    { label: 'Closed', value: 'closed', color: '#ef4444' },
];

export const studentStatusList = [
    { label: "Approved", value: "approved" },
    { label: "Pending", value: "pending" },
    { label: "Re-sumbitted", value: "re-sumbitted" },
    { label: "Rework", value: "rework" },
    { label: "Draft", value: "draft" },
]

export const reviewerStatusList = [
    { label: "Approved", value: "approved" },
    { label: "Pending", value: "pending" },
    { label: "Re-Submitted", value: "re-submitted" },
    { label: "Send for Rework", value: "rework" },
]

export const callStatusList = (type) => {
    const list = [
        { label: "Completed", value: "completed" },
        { label: "Scheduled", value: "scheduled" },
        { label: "Pending", value: "pending" },
        { label: "Cancelled", value: "cancelled" },
    ]

    if (type === 'counseling-leads') {
        list.push({ label: "Rescheduled", value: "Rescheduled" },)
    }
    return list
}

export const reviewStatusList = [
    { label: "Pending", value: "pending" },
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
]

export const normalStatusList = [
    { label: "Live", value: "live" },
    { label: "Deactivated", value: "deactivated" },
]

export const webLeadsStatusList = [
    { label: 'Pending', value: 'pending' },
    { label: 'Interested', value: 'interested' },
    { label: 'Call back request', value: 'call_back_request' },
    { label: 'Not Interested', value: 'not_interested' },
    { label: 'Not Eligible', value: 'not_eligible' },
    { label: 'Prospect for next session', value: 'prospect_for_next_session' },
    { label: 'Registration Done', value: 'registration_done' },
    { label: 'Paid', value: 'paid' },
];

export const paymentStatusList = [
    { label: "Partial", value: "partial" },
    { label: "EMI", value: "emi" },
    { label: "Full", value: "full" },
]

export const currentyList = [
    { label: "INR", value: "inr" },
    { label: "USD", value: "usd" },
]

export const paymentRequestStatusList = [
    { label: "Succeeded", value: "succeeded" },
    { label: "Pending", value: "pending" },
    { label: "Failed", value: "failed" },
]

const dateFieldStyle = {
    '& .MuiInputBase-root': {
        height: '35px',
        fontSize: { xl: '13px', lg: '13px', md: '13px', md: '13px', xs: '12px' }, width: '100%',
    },
    '& input': {
        padding: '6px 8px',
        width: '100%',
    },

}
const utmTypeList = {
    "utm_campaign": { list: [], placeholder: "All campaign" },
    "utm_medium": { list: [], placeholder: "All medium" },
    "utm_content": { list: [], placeholder: "All content" },
    "utm_source": { list: [], placeholder: "All source" },
    "utm_term": { list: [], placeholder: "All term" },
}
const utmKeys = Object.keys(utmTypeList)

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MultMenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


export default function CommonFilterTab({ isReferalManagementExportBtn, isPaymentExportBtn, isAdmissionExportBtn, isExportBtn,handleExport,isExporting, searchPlaceholder = "Search ...", detailType = "Details", showCount, rowCount, fetchList = () => { }, type = "", module = "", isTag, isStatus, isEnrollment, isCategory, isDate, isDateRange, isUtmFilter, utmFilterOptions = utmTypeList }) {
    const paginationSlice = useSelector(state => state.pagination)
    const location = useLocation()
    const defaultValue = (paginationSlice?.pathname == location?.pathname && (type ? type === paginationSlice?.type : true) && paginationSlice?.searchOptions) ? paginationSlice?.searchOptions : {}
    const [search, setSearch] = React.useState(defaultValue?.search || '')
    const [searchText, setSearchText] = React.useState(defaultValue?.search || '')
    const [tag, setTag] = React.useState(defaultValue?.tag || '')
    const [enrollmentWindow, setEnrollmentWindow] = React.useState(defaultValue?.enrollmentWindow || '')
    const [status, setStatus] = React.useState(defaultValue?.status || '')
    const [category, setCategory] = React.useState(defaultValue?.category || '')
    const [courseCategoryList, setCourseCategoryList] = React.useState([])
    const [statusList, setStatusList] = useState(normalStatusList)
    const [startDate, setStartDate] = React.useState(defaultValue?.startDate ? dayjs(defaultValue?.startDate) : null);
    const [endDate, setEndDate] = React.useState(defaultValue?.endDate ? dayjs(defaultValue?.endDate) : null);
    const [tabIndex, setTabIndex] = useState(paginationSlice?.activeTab || 0);
    const defaultUtmValues = {}
    utmKeys?.forEach(key => {
        defaultUtmValues[key] = defaultValue?.[key] || ''
    })
    const [utmDetails, setutmDetails] = React.useState(defaultUtmValues)
    const handleStartDateChange = (newValue) => {
        setStartDate(newValue);
        if (endDate && dayjs(newValue).isAfter(endDate)) {
            setEndDate(null);
        }
    };

    const handleEndDateChange = (newValue) => {
        if (startDate && dayjs(newValue).isBefore(startDate)) {
            alert("End date cannot be earlier than start date!");
            return;
        }
        setEndDate(newValue);
    };

    const getFilterObject = () => {
        return {
            ...(search ? { search } : {}),
            ...(tag ? { tag } : {}),
            ...(enrollmentWindow ? { enrollmentWindow } : {}),
            ...(status ? { status } : {}),
            ...(category ? { category } : {}),
            ...(startDate ? { startDate: dayjs(startDate).format("YYYY-MM-DD") } : {}),
            ...(endDate ? { endDate: dayjs(endDate).format("YYYY-MM-DD") } : {}),
            ...Object.fromEntries(
                Object.entries(utmDetails || {})
                    .filter(([, value]) =>
                        Array.isArray(value) ? value.length > 0 : Boolean(value)
                    )
                    .map(([key, value]) => [
                        key,
                        Array.isArray(value) ? value : value,
                    ])),
        }
    };

    useEffect(() => {
        fetchList && fetchList(getFilterObject())
    }, [tag, enrollmentWindow, status, search, category, utmDetails])

    useEffect(() => {
        if (isDateRange && (!startDate || !endDate)) return
        fetchList && fetchList(getFilterObject())
    }, [endDate, startDate])

    const debouncedFunc = useMemo(() => debounce((text) => {
        setSearch(text);
    }, 500),
        []
    );

    useEffect(() => {
        if (isCategory) {
            fetchCourseCategoryList(setCourseCategoryList)
        }
    }, [isCategory])

    useEffect(() => {
        if (module == "student") {
            setStatusList(studentStatusList)
        } else if (module == "reviewer" || ["university-course",].includes(type)) {
            setStatusList(reviewerStatusList)
        } else if (["schedule-call",].includes(type)) {
            setStatusList(callStatusList(type))
        } else if (['reviews-rating']?.includes(type)) {
            setStatusList(reviewStatusList)
        } else if (['web-leads', 'counseling-leads', 'referral-management']?.includes(type)) {
            setStatusList(webLeadsStatusList)
        } else if (['payment-request', 'payment']?.includes(type)) {
            setStatusList(paymentRequestStatusList)
        }
    }, [module])

    // console.log("utm", Object.fromEntries(
    //     Object.entries(utmDetails || {})
    //         .filter(([, value]) =>
    //             Array.isArray(value) ? value.length > 0 : Boolean(value)
    //         )
    //         .map(([key, value]) => [
    //             key,
    //             Array.isArray(value) ? value.join(",") : value,
    //         ])
    // )
    // );

    const [downloading, setDownloading] = useState(false)
    const { showSuccessNotification, showErrorNotification, } = useNotification()
    const downloadLeadDetails = () => {
        if (downloading) return
        downloadWebLeads({ setDownloading, filterData: {} })
            .then(res => {
                showSuccessNotification("Successfully downloaded")
            }).catch(error => {
                showErrorNotification(error?.message)
            })
    }

    const [localSearchTerms, setLocalSearchTerms] = React.useState({});

    return (
        <>
            <Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 2,
                        my: 0,
                        px: 2,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Box>
                        <Typography sx={{ fontSize: '14px', fontWeight: '500', color: '#000' }}>{detailType}</Typography>
                        <Box
                            sx={{
                                fontSize: '12px',
                                color: '#4b5563',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                fontWeight: 500,
                            }}
                        >
                            <Typography component="span" sx={{ fontSize: '12px', }}>Showing</Typography>
                            <Typography component="span" sx={{ fontSize: '12px', fontWeight: 600, }}>
                                {showCount}
                            </Typography>
                            <Typography component="span">from</Typography>
                            <Typography component="span" sx={{ fontSize: '12px', fontWeight: 600 }}>
                                {rowCount}
                            </Typography>
                            <Typography component="span" sx={{ fontSize: '12px', }}>results</Typography>
                        </Box>
                    </Box>
                    {isDate && <Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Box sx={{ display: "flex", gap: 2 }}>
                                <DatePicker sx={{
                                    '& .MuiSvgIcon-root': {
                                        fontSize: '21px'
                                    },
                                    '& .MuiPickersInputBase-root': {
                                        height: '30px',
                                        borderRadius: '40px',
                                        fontSize: '14px',
                                        width: '190px'
                                    },

                                    '& .MuiInputLabel-formControl': {
                                        top: '-11px',
                                        fontSize: '14px',
                                    }
                                    ,
                                    ' & .MuiFormLabel-filled': {
                                        top: '0'
                                    }
                                    , '& .MuiInputLabel-shrink': {
                                        top: '0px',
                                    },

                                }}
                                    label={isDateRange ? "Start date" : "Date"}
                                    value={startDate}
                                    onChange={handleStartDateChange}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        sx={dateFieldStyle}
                                    />}
                                />
                                {isDateRange && <DatePicker
                                    sx={{
                                        '& .MuiSvgIcon-root': {
                                            fontSize: '21px'
                                        },
                                        '& .MuiPickersInputBase-root': {
                                            height: '30px',
                                            borderRadius: '40px',
                                            fontSize: '14px',
                                            width: '190px'
                                        }, '& .MuiInputLabel-formControl': {
                                            top: '-11px',
                                            fontSize: '14px',

                                        }
                                        , ' & .MuiFormLabel-filled': {
                                            top: '0'
                                        }
                                        , '& .MuiInputLabel-shrink': {
                                            top: '0px',
                                        },



                                    }}
                                    label="End date"
                                    value={endDate}
                                    onChange={handleEndDateChange}
                                    renderInput={(params) => <TextField {...params} sx={dateFieldStyle} />}
                                    minDate={startDate} // ✅ ensures endDate is after startDate
                                />}
                            </Box>
                        </LocalizationProvider>
                    </Box>}
                    <Box
                        sx={{
                            flexGrow: 1,
                            maxWidth: '500px',
                            marginLeft: 'auto',
                        }}
                    >
                        <input
                
                            type="text"
                            placeholder={searchPlaceholder}
                            value={searchText}
                            onChange={(e) => { setSearchText(e.target.value); debouncedFunc(e?.target?.value) }}
                            style={{
                                width: '100%',
                                padding: '6px 12px',
                                borderRadius: '50px',
                                border: '1px solid #ccc',
                                height: '30px',
                                fontSize: '12px',
                            }}
                        />
                    </Box>
                    {isStatus && <Select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        displayEmpty
                        size="small"
                        IconComponent={KeyboardArrowDownIcon}
                        sx={{
                            minWidth: 140,
                            borderRadius: '50px',
                            fontSize: '13px',
                            height: '30px',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderRadius: '50px',
                            },
                        }}
                    >
                        <MenuItem value="" sx={{ fontSize: '13px' }}>
                            All Status
                        </MenuItem>
                        {statusList?.map(item => <MenuItem key={item?.value} value={item?.value} sx={{ fontSize: '13px' }}>
                            {item.label}
                        </MenuItem>)}

                    </Select>}
                    {isTag && <Select
                        value={tag}
                        onChange={(e) => setTag(e.target.value)}
                        displayEmpty
                        size="small"
                        sx={{
                            minWidth: 160,
                            borderRadius: '50px',
                            height: '30px',
                            fontSize: '13px',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderRadius: '50px',
                            },
                        }}
                    >
                        <MenuItem value="" sx={{ fontSize: '13px' }}>
                            All Tags
                        </MenuItem>
                        {tagOptions.map((tag) => (
                            <MenuItem key={tag.value} value={tag.value} sx={{ fontSize: '13px' }}>
                                {tag.label}
                            </MenuItem>
                        ))}
                    </Select>}
                    {isEnrollment && <Select
                        value={enrollmentWindow}
                        onChange={(e) => setEnrollmentWindow(e.target.value)}
                        displayEmpty
                        size="small"
                        sx={{
                            minWidth: 160,
                            borderRadius: '50px',
                            fontSize: '13px',
                            height: '30px',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderRadius: '50px',
                            },
                            '& .MuiSelect-select': {
                                borderRadius: '50px',
                                fontSize: '13px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '3px',
                            },
                        }}
                    >
                        <MenuItem value="" sx={{ fontSize: '13px' }}>
                            All Enrollment
                        </MenuItem>
                        {enrollmentOptions.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: '3px' }}>
                                <FiberManualRecordIcon
                                    sx={{
                                        fontSize: 10,
                                        color: opt.color,
                                    }}
                                />
                                {opt.label}
                            </MenuItem>
                        ))}
                    </Select>}

                    {isCategory && <Select
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        displayEmpty
                        size="small"
                        sx={{
                            minWidth: 160,
                            borderRadius: '50px',
                            fontSize: '13px',
                            height: '30px',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderRadius: '50px',
                            },
                            '& .MuiSelect-select': {
                                borderRadius: '50px',
                                fontSize: '13px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '3px',
                            },
                        }}
                    >
                        <MenuItem value="" sx={{ fontSize: '13px' }}>
                            All Category
                        </MenuItem>
                        {courseCategoryList?.map((opt) => (
                            <MenuItem key={opt?.label} value={opt?.value} sx={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: '3px' }}>
                                {opt?.label}
                            </MenuItem>
                        ))}
                    </Select>}

                    {
                        isExportBtn &&
                        <Box sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 2,
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                        }}>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 2,
                                    my: 0,
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <Button
                                    variant="contained"
                                    color="#363853"
                                    startIcon={<ExportIcon />}
                                    disabled={isExporting} onClick={handleExport}
                                    sx={{
                                        background: '#EFEFEF',
                                        border: '1px solid #E6E7E8',
                                        borderRadius: '8px',
                                        textTransform: "none", // Capitalization remove
                                        fontWeight: 500
                                    }}
                                >
                                    Export
                                </Button>
                            </Box>
                        </Box>
                    }
                    {
                        isReferalManagementExportBtn &&
                        <Box sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 2,

                            justifyContent: 'flex-end',
                            alignItems: 'center',
                        }}>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 2,
                                    my: 0,
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <Button
                                    variant="contained"
                                    color="#363853"
                                    startIcon={<ExportIcon />}
                                    sx={{
                                        background: '#EFEFEF',
                                        border: '1px solid #E6E7E8',
                                        borderRadius: '8px',
                                        textTransform: "none", // Capitalization remove
                                        fontWeight: 500
                                    }}
                                >
                                    Export
                                </Button>
                            </Box>
                        </Box>
                    }
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between', px: 2, flexWrap: 'wrap' }}>
                    <Box>
                        {isUtmFilter && (
                            <>
                                <Box display={"flex"} gap={1} sx={{ flexWrap: 'wrap' }}>
                                    {utmKeys?.map((key) => {
                                        const filteredList =
                                            utmFilterOptions?.[key]?.list?.filter((item) =>
                                                item.toLowerCase().includes((localSearchTerms[key] || "").toLowerCase())
                                            )
                                            || [];
                                        return (
                                            <Box
                                                key={key}
                                                sx={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: 2,
                                                    my: 2,
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Select
                                                    multiple
                                                    value={utmDetails?.[key] || []}
                                                    onChange={(e) =>
                                                        setutmDetails({
                                                            ...utmDetails,
                                                            [key]: e.target.value, // array of selected items
                                                        })
                                                    }

                                                    displayEmpty
                                                    size="small"
                                                    IconComponent={KeyboardArrowDownIcon}
                                                    MenuProps={MultMenuProps}
                                                    sx={{
                                                        width: { xl: '180px', lg: '170px', md: '180px', sm: '180px', xs: '180px' },
                                                        borderRadius: "50px",
                                                        fontSize: "13px",
                                                        height: "30px",
                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                            borderRadius: "50px",
                                                        },
                                                    }}
                                                    renderValue={(selected) => {
                                                        if (!selected || selected.length === 0) {
                                                            return (
                                                                <span style={{ fontSize: "13px", color: "#888" }}>
                                                                    {utmFilterOptions[key]?.placeholder}
                                                                </span>
                                                            );
                                                        }
                                                        return selected.join(", "); // just show text
                                                    }}
                                                >
                                                    <ListSubheader
                                                        disableRipple
                                                        disableTouchRipple
                                                        sx={{
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 999,
                                                            background: '#fff !important',
                                                            fontFamily: 'Manrope'
                                                        }}
                                                    >
                                                        <TextField
                                                            sx={{
                                                                padding: '4px 0px',
                                                                width: '100%',
                                                                '& .MuiInputBase-formControl': {
                                                                    height: '30px',
                                                                    borderRadius: '40px',
                                                                    fontSize: '13px'
                                                                }
                                                            }}
                                                            autoComplete='off'
                                                            placeholder="Search..."
                                                            value={localSearchTerms[key] || ""}
                                                            onChange={(e) => {
                                                                setLocalSearchTerms(prev => ({ ...prev, [key]: e.target.value }));
                                                            }}
                                                            onKeyDown={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();
                                                            }}
                                                        />
                                                    </ListSubheader>

                                                    {filteredList.length > 0 ? (
                                                        filteredList.map((item) => (
                                                            <MenuItem
                                                                key={item}
                                                                value={item}
                                                                sx={{ fontSize: "13px", padding: "4px 10px", textWrap: "auto" }}
                                                            >
                                                                <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                                    <Checkbox
                                                                        size="small"
                                                                        checked={(utmDetails?.[key] || []).includes(item)}
                                                                    />
                                                                    {item}
                                                                </Box>
                                                            </MenuItem>
                                                        ))
                                                    ) : (
                                                        <MenuItem disabled sx={{ fontSize: "13px" }}>
                                                            No results found
                                                        </MenuItem>
                                                    )}
                                                </Select>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </>
                        )}
                    </Box>
                </Box>
            </Box>
        </>
    )
}
